import React, { FC } from 'react'
import { Coverage as FHIRCoverageType } from '@teschglobal/tg-fhir-react-components/dist/types'
import FhirLoader from '../../../FhirLoader'
import { Coverage as TGCoverage } from '@teschglobal/tg-fhir-react-components'
import useFhirConfig from '../../../../hooks/admin/useFhirConfig'
import { sortCoveragesByStartDate } from '../../../../utils/fhirUtils/coverage'

type CoverageProps = {
  coverageData: { entry: { resource: FHIRCoverageType }[] } | undefined;
  loading: boolean;
}

const Coverage: FC<CoverageProps> = ({ coverageData, loading }) => {
  const { patientAccessFhirConfig, handleSelectOrganization } = useFhirConfig()

  if (loading) {
    return <FhirLoader message="Loading Coverage..." />
  }

  let sortedCoverages: FHIRCoverageType[] = []

  if (coverageData?.entry) {
    const coverages = coverageData.entry.map(e => e.resource)
    sortedCoverages = sortCoveragesByStartDate(coverages)
  }

  const count = sortedCoverages.length

  return (
    <div>
      <div className='my-3 fw-bold' role="status" aria-live="polite">
        {count} record(s) found
      </div>

      {count === 0 && (
        <div className="text-center" aria-live="polite">
          Not Found
        </div>
      )}
      <section>
        {sortedCoverages.map((resource: any, index: number) => (
          <div key={resource.id || index} className="mb-4">
            <TGCoverage
              data={resource}
              fhirApiConfig={patientAccessFhirConfig}
              onSelectOrganization={handleSelectOrganization}
            />

          </div>
        ))}
      </section>
    </div>
  )
}

export default Coverage
